export const PRESCRIPTION_ONLY_PARTNER_IDS = new Set([
  'cox.atlanta.us',
  'cox.central.us',
  'cox.east.us',
  'cox.west.us',
  'devmaintestclient.default.us',
])
